export enum Types {
	EXCLUIR_MENSAGEM_ERRO_REQUEST = '@SGU/EXCLUIR_MENSAGEM_ERRO_REQUEST',
	EXCLUIR_MENSAGEM_ERRO_SUCCESS = '@SGU/EXCLUIR_MENSAGEM_ERRO_SUCCESS',
	EXCLUIR_MENSAGEM_ERRO_FAILURE = '@SGU/EXCLUIR_MENSAGEM_ERRO_FAILURE',
	EXCLUIR_MENSAGEM_ERRO_CLEAR = '@SGU/EXCLUIR_MENSAGEM_ERRO_CLEAR',
}

export interface ExcluirMensagemErro {
	status: number;
	data: null | IExcluirMensagemErro;
}

export interface IExcluirMensagemErro {
	status: string;
	statusMensagem: string;
}

export interface ExcluirMensagemErroRequest {
	id?: number | string;
}
